<app-header></app-header>

<div class="container-fluid" style="width: 80%;">

  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Notifiche</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Gestione Notifiche</h4>
    </div>
  </div>

  <mat-card class="p-2" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Filtri di ricerca</mat-card-title>
    </mat-card-header>

    <form [formGroup]="formFiltri" (ngSubmit)="applyFilter()">
      <mat-card-content>
        <div class="row d-flex mt-4">
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Data da</mat-label>
              <input matInput [matDatepicker]="pickerDa" formControlName="dataDa">
              <mat-datepicker-toggle matIconSuffix [for]="pickerDa"></mat-datepicker-toggle>
              <mat-datepicker #pickerDa></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Data a</mat-label>
              <input matInput [matDatepicker]="pickerA" formControlName="dataA">
              <mat-datepicker-toggle matIconSuffix [for]="pickerA"></mat-datepicker-toggle>
              <mat-datepicker #pickerA></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Cerca nel messaggio</mat-label>
              <input matInput placeholder="Testo del messaggio..." formControlName="cerca" (input)="applyFilter()">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>

      <mat-card-actions align="start">
        <button mat-flat-button color="primary" type="submit">
          <mat-icon>search</mat-icon> Cerca
        </button>
        <div style="margin-left: 0.5rem;"></div>
        <button mat-button type="button" (click)="resetFiltri()">
          <mat-icon>clear</mat-icon> Pulisci filtri
        </button>
      </mat-card-actions>
    </form>
  </mat-card>

  <div class="alert alert-primary mt-4 mb-4" role="alert">
    Notifiche visualizzate: <b>{{ dataSource.filteredData.length }}</b>
  </div>

  <mat-card class="p-2" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Elenco Notifiche</mat-card-title>
    </mat-card-header>

    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Da leggere"></mat-tab>
      <mat-tab label="Lette"></mat-tab>
    </mat-tab-group>

    <div style="height: 4px;"> <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>

    <div class="table-container mt-2" [style.opacity]="isLoading ? 0 : 1">
      <table mat-table [dataSource]="dataSource" class="w-100">

        <ng-container matColumnDef="dataOra">
          <th mat-header-cell *matHeaderCellDef>Data e ora</th>
          <td mat-cell *matCellDef="let element">
            {{ getDisplayDataOra(element) | date : "dd/MM/yyyy HH:mm:ss" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="messaggio">
          <th mat-header-cell *matHeaderCellDef>Messaggio</th>
          <td mat-cell *matCellDef="let element">
            {{ getDisplayMessaggio(element) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-button color="primary" *ngIf="tabIndex === 0" (click)="leggi(element)">
              <span class="me-1">Leggi</span>
              <mat-icon>done_all</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="apri">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-button color="accent" (click)="apriRichiesta(element)">
              <span>Apri richiesta</span>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tabIndex === 0 ? displayedColumnsNonLette : displayedColumnsLette"></tr>
        <tr mat-row *matRowDef="let row; columns: tabIndex === 0 ? displayedColumnsNonLette : displayedColumnsLette;">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-results-row text-center p-4" [attr.colspan]="4">
            Nessuna notifica trovata.
          </td>
        </tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Seleziona pagina"></mat-paginator>
    </div>
  </mat-card>
</div>

<app-footer></app-footer>